import { createTheme } from '@material-ui/core/styles';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    table?: {
      header?: {
        rowBackground: React.CSSProperties['color'];
        contrastText: React.CSSProperties['color'];
      };
      nestedRow?: {
        nav: {
          tabBackground: React.CSSProperties['color'];
        };
      };
    };
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    table?: {
      header?: {
        rowBackground: React.CSSProperties['color'];
        contrastText: React.CSSProperties['color'];
      };
      nestedRow?: {
        nav: {
          tabBackground: React.CSSProperties['color'];
        };
      };
    };
  }
}

const theme = createTheme({
  typography: {
    fontFamily: ['Roboto Condensed'].join(','),
  },
  palette: {
    primary: {
      main: '#282283',
    },
    secondary: {
      main: 'rgb(213,235,223)',
    },
    error: {
      main: '#d32f2f',
    },
  },
  table: {
    header: {
      rowBackground: '#d5d8d8',
      contrastText: '#000000',
    },
    nestedRow: {
      nav: {
        tabBackground: '#aecccb',
      },
    },
  },
  overrides: {},
});

export default theme;
